import React, { useEffect } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { PageLayout } from "./components/pageLayout";
import ProfileContent from "./pages/appPage";
import PublicPage from "./pages/publicPage";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAHPG8PzhYz5FD_u0u072vUxJit9RwYEU4",
    authDomain: "little-red-button.firebaseapp.com",
    projectId: "little-red-button",
    storageBucket: "little-red-button.appspot.com",
    messagingSenderId: "357766589537",
    appId: "1:357766589537:web:8baa8230e74e5a730f8e20",
    measurementId: "G-ERLS8ERBMF"
};

const identity = {
    "associatedApplications": [
      {
        "applicationId": "a6102f93-fc2c-4664-afb9-7e642a297dd6"
      }
    ]
  }

// function ProfileContent() {
//     const { instance, accounts } = useMsal();
//     const [graphData, setGraphData] = useState(null);

//     const name = accounts[0] && accounts[0].name;

//     function RequestProfileData() {
//         const request = {
//             ...loginRequest,
//             account: accounts[0]
//         };

//         // Silently acquires an access token which is then attached to a request for Microsoft Graph data
//         instance.acquireTokenSilent(request).then((response) => {
//             callMsGraph(response.accessToken).then(response => setGraphData(response));
//         }).catch((e) => {
//             instance.acquireTokenPopup(request).then((response) => {
//                 callMsGraph(response.accessToken).then(response => setGraphData(response));
//             });
//         });
//     }

//     function sendTheEmail() {
//         const request = {
//             ...loginRequest,
//             account: accounts[0]
//         };

//         // Silently acquires an access token which is then attached to a request for Microsoft Graph data
//         instance.acquireTokenSilent(request).then((response) => {
//             callGraphEmail(response.accessToken, "shawtheswift@gmail.com").then(response => console.log(response));
//         }).catch((e) => {
//             instance.acquireTokenPopup(request).then((response) => {
//                 callGraphEmail(response.accessToken).then(response => console.log(response));
//             });
//         });
//     }

//     return (
//         <>
//             <h5 className="card-title">Welcome {name}</h5>
//             {graphData ?
//                 <ProfileData graphData={graphData} />
//                 :
//                 <Button variant="secondary" onClick={RequestProfileData}>Request Profile Information</Button>
//             }
//             <div class="row justify-content-center">
//                 <br />
//                 <Form style={{ width: "25%" }}>
//                     <Form.Group className="mb-3" controlId="formBasicEmail" >
//                         <Form.Label>Recipient's Email Address</Form.Label>
//                         <Form.Control type="email" placeholder="Enter email" />
//                     </Form.Group>
//                     <div class="row justify-content-center">
//                         <Button variant="primary" type="submit">
//                             Save
//                         </Button>
//                     </div>
//                 </Form>
//             </div>
//             <br />
//             <div class="row justify-content-center">
//                 <Button style={{ background: "red", width: "25%", height: "80px" }} onClick={sendTheEmail}>I'm in trouble</Button>
//             </div>
//         </>
//     );
// };


function App() {
    const app = initializeApp(firebaseConfig);
    // const analytics = getAnalytics(app);

    useEffect(() => {
        document.title = "Little Red Button";
    }, []);

    return (
        <>
            <PageLayout>
                <AuthenticatedTemplate>
                    <ProfileContent />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <PublicPage />
                </UnauthenticatedTemplate>
            </PageLayout>
        </>
    );
}

export default App;